export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/party.worker.fb344b43.worker.js");
}
